import { OscillometryTestAcceptabilitySummary, TestResults } from '../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import { ParameterType, ParameterTypeName } from './ParameterTypes';

declare let rootUrl: string;

export function MapOscillometryTestAcceptabilitySummaries(testResults: TestResults[]): Array<OscillometryTestAcceptabilitySummary> {
    return testResults.map(tr => {
        return {
            Accepted: tr.OverreaderAcceptability,
            TestId: tr.TestId,
            Ax: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_AX).Value,
            R5: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R5).Value,
            R20: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R20).Value,
            R5R20: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R520).Value,
            R7: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R7).Value,
            R7R20: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_R720).Value,
            X5: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_X5).Value,
            Fres: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_OSCILLOMETRY_FRES).Value,
        } as OscillometryTestAcceptabilitySummary;
    });
}

